import { fromJS } from "immutable";
import { isEqual } from "lodash";

import { createReducer } from "./../../../redux/reducers/functions";
import {
  PRESENCE_SET_DETAILS_DAY,
  PRESENCE_SET_ATTENDANCE_UPDATED_DETAILS_DAY,
  PRESENCE_SET_ATTENDANCE_UPDATE_ERRORS_DETAILS_DAY,
  PRESENCE_RESET_ATTENDANCE_ERRORS_DETAILS_DAY,
  PRESENCE_SET_MEAL_PACKAGE_UPDATED_DETAILS_DAY,
  PRESENCE_SET_MEAL_PACKAGE_UPDATE_ERRORS_DETAILS_DAY,
  PRESENCE_RESET_MEAL_PACKAGE_ERRORS_DETAILS_DAY,
  PRESENCE_SET_TRIP_UPDATED_DETAILS_DAY,
  PRESENCE_SET_TRIP_UPDATE_ERRORS_DETAILS_DAY,
  PRESENCE_RESET_TRIP_ERRORS_DETAILS_DAY
} from "../actions/presenceDetailsDay";
import { PRESENCE_ERASE_DETAILS_DAY } from "../actions/presenceDetailsWeek";

const initialState = fromJS({
  userId: null,
  userName: null,
  userRoleId: null,
  userData: [],
  isLoading: false,
  updated: null,
  updateMealPackageErrors: null,
  updateTripErrors: null,
  updateAttendanceErrors: null
});

const detailsDayList = {
  [PRESENCE_SET_DETAILS_DAY]: (state, action) => {
    const { user_id, user_fullname, user_role_id, data: newDay } = action.payload;
    let days = state.get("userData") || [];

    const daysToRemove = newDay.map(d => d.date_iso);

    days = [...days.filter(d => daysToRemove.indexOf(d.date_iso) === -1), ...newDay];
    const sortedDays = days.sort((d1, d2) => new Date(d1.date_iso) - new Date(d2.date_iso));
    return state
      .set("userId", user_id)
      .set("userName", user_fullname)
      .set("userRoleId", user_role_id)
      .set("userData", sortedDays);
  }
};

const eraseDetailsDayList = {
  [PRESENCE_ERASE_DETAILS_DAY]: state => {
    return state.set("userData", []);
  }
};
const updateAttendanceDay = {
  [PRESENCE_SET_ATTENDANCE_UPDATED_DETAILS_DAY]: (state, action) => {
    const { payload, index } = action;
    const dayTime = payload.slot.id === 1 ? "morning" : "afternoon";
    const stateUpdated = state.updateIn(["userData", index.toString(), "attendances", dayTime], () => payload);

    return stateUpdated;
  }
};

const updateMealPackageDay = {
  [PRESENCE_SET_MEAL_PACKAGE_UPDATED_DETAILS_DAY]: (state, action) => {
    const { payload, index } = action;
    const stateUpdated = state.updateIn(
      ["userData", index.toString(), "meal_packages", "0"],
      () => payload.meal_package
    );

    return stateUpdated;
  }
};

const updateMealPackageErrors = {
  [PRESENCE_SET_MEAL_PACKAGE_UPDATE_ERRORS_DETAILS_DAY]: (state, action) => {
    const { payload } = action;

    return state.set("updateMealPackageErrors", payload);
  }
};

const resetMealPackageErrors = {
  [PRESENCE_RESET_MEAL_PACKAGE_ERRORS_DETAILS_DAY]: state => {
    return state.set("updateMealPackageErrors", null);
  }
};

const updateTrip = {
  [PRESENCE_SET_TRIP_UPDATED_DETAILS_DAY]: (state, action) => {
    const { payload, index } = action;

    return state.updateIn(["userData", index.toString(), "trips"], tripsArray => {
      return tripsArray.map(item => {
        if (isEqual(item.id, payload.id)) return payload;
        return item;
      });
    });
  }
};

const updateTripErrors = {
  [PRESENCE_SET_TRIP_UPDATE_ERRORS_DETAILS_DAY]: (state, action) => {
    const { payload } = action;

    return state.set("updateTripErrors", payload);
  }
};

const resetTripErrors = {
  [PRESENCE_RESET_TRIP_ERRORS_DETAILS_DAY]: state => {
    return state.set("updateTripErrors", null);
  }
};

const updateAttendanceErrors = {
  [PRESENCE_SET_ATTENDANCE_UPDATE_ERRORS_DETAILS_DAY]: (state, action) => {
    const { payload } = action;

    return state.set("updateAttendanceErrors", payload);
  }
};

const resetAttendanceErrors = {
  [PRESENCE_RESET_ATTENDANCE_ERRORS_DETAILS_DAY]: state => {
    return state.set("updateAttendanceErrors", null);
  }
};

const presenceReducer = createReducer(initialState, {
  ...detailsDayList,
  ...updateAttendanceDay,
  ...updateMealPackageDay,
  ...updateMealPackageErrors,
  ...resetMealPackageErrors,
  ...updateTrip,
  ...updateTripErrors,
  ...resetTripErrors,
  ...updateAttendanceErrors,
  ...resetAttendanceErrors,
  ...eraseDetailsDayList
});

export default presenceReducer;



// WEBPACK FOOTER //
// src/modules/presence/reducers/presenceDetailsDay.js